'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { CommercialTermsBody } from './-components/CommercialTermsBody';
export const Route = createFileRoute('/_staff/customer/$customerId/_layout/commercial-terms')({
  component: CommercialTermsBody
});